import { Container, Box, Paper, Typography, Grid, Stack, IconButton, TextField, Button } from "@mui/material";
import {
    Facebook,
    Instagram,
    YouTube,
} from "@mui/icons-material";
import { FaTiktok } from "react-icons/fa";
import {
Phone,
Email
} from "@mui/icons-material";
import { useEffect, useRef, useState } from "react";
import { enviarContacto } from "../../Services/Contacto";
import StatusModal from "../../utils/StatusModal";

export const ContactoHome = () => {
  const [formulario, setFormulario] = useState({
    nombre: "",
    email: "",
    telefono: "",
    mensaje: "",
});

const [modal, setModal] = useState({
    open: false,
    status: "loading",
    title: "",
    message: "",
});
  const sectionRef = useRef(null);

const [visible,setVisible] = useState(false);


useEffect(()=>{

const observer = new IntersectionObserver(
([entry])=>{

if(entry.isIntersecting){

setVisible(true);

}else{

setVisible(false);

}

},
{
threshold:.2
}
);


if(sectionRef.current){

observer.observe(sectionRef.current);

}


return ()=>observer.disconnect();


},[]);

const handleChange = (e) => {
    const { name, value } = e.target;

    setFormulario((prev) => ({
        ...prev,
        [name]: value,
    }));
};


const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formulario.nombre.trim()) {
        setModal({
            open: true,
            status: "error",
            title: "Datos incompletos",
            message: "Por favor, ingresa tu nombre.",
        });
        return;
    }

    if (!formulario.email.trim()) {
        setModal({
            open: true,
            status: "error",
            title: "Datos incompletos",
            message: "Por favor, ingresa tu correo electrónico.",
        });
        return;
    }

    if (!formulario.mensaje.trim()) {
        setModal({
            open: true,
            status: "error",
            title: "Datos incompletos",
            message: "Por favor, ingresa tu mensaje.",
        });
        return;
    }

    // Modal de carga
    setModal({
        open: true,
        status: "loading",
        title: "Enviando mensaje",
        message: "Estamos procesando tu solicitud...",
    });

    try {
        await enviarContacto({
            nombre: formulario.nombre,
            email: formulario.email,
            telefono: formulario.telefono,
            mensaje: formulario.mensaje,
        });

        // Limpiar formulario
        setFormulario({
            nombre: "",
            email: "",
            telefono: "",
            mensaje: "",
        });

        // Modal éxito
        setModal({
            open: true,
            status: "success",
            title: "Mensaje enviado",
            message:
                "Tu mensaje fue enviado correctamente. Nos pondremos en contacto contigo.",
        });

    } catch (error) {

        console.error(
            "Error al enviar contacto:",
            error
        );

        let mensaje = "No fue posible enviar el mensaje. Inténtalo nuevamente.";

        if (error.response?.data?.errors) {
            const errores = error.response.data.errors;

            const primerError =
                Object.values(errores)[0]?.[0];

            if (primerError) {
                mensaje = primerError;
            }
        }

        setModal({
            open: true,
            status: "error",
            title: "No se pudo enviar",
            message: mensaje,
        });
    }
};
    return(
        <Container 
      ref={sectionRef}
      maxWidth='lg'
    >
       <Box
sx={{

position:"relative",

zIndex:10,

mb:"-40px",


opacity:visible?1:0,


transform:visible
?
"translateY(0) scale(1)"
:
"translateY(80px) scale(.95)",


transition:"1s cubic-bezier(.17,.67,.43,1.3)"

}}
>
        <Paper
elevation={0}
sx={{

background:"#e3effb",

p:{xs:2,sm:3,md:5,lg:8},

borderRadius:"30px",

boxShadow:"0 20px 60px rgba(0,0,0,.12)",


opacity:visible?1:0,


transform:visible
?
"translateY(0)"
:
"translateY(40px)",


transition:"1s ease",

transitionDelay:".2s"

}}
>
            <Grid container spacing={3}>
                <Grid size={{sm:12, md:4}}>
                    <Box sx={{
                      opacity:visible?1:0,

transform:visible
?
"translateX(0)"
:
"translateX(-40px)",

transition:".8s ease",
                    }}>
                        <Typography
sx={{
color:"#484a75",
fontWeight:800,

fontSize:{
    xs:'1.2rem',
sm:"1.5rem",
md:"2rem"
}
}}
>
COMUNÍCATE
</Typography>
                      <Typography
sx={{
color:"#484a75",
fontWeight:800,
lineHeight:1,

fontSize:{
    xs:'1.2rem',
sm:"1.5rem",
md:"2rem"
}
}}
>
CON NOSOTROS
</Typography>
  <Typography
            sx={{
              fontWeight: 500,
              color: "#666",
              mt:2,
              fontSize: {
                xs: "0.8rem",
                sm: "1rem",
                md:"1rem"
                
              },
              width:{xs:'100%',sm:'80%'},
              lineHeight: 1.1,
              textAlign: "left",
            }}
          >Tenemos distintos canales de 
comunicación además de nuestras 
redes sociales.</Typography>
                    </Box>
                    <Box sx={{ mt: 5 }}>

    <Stack direction="row" spacing={2}>

        {[
            {
                icon: <Facebook />,
                url: "https://www.facebook.com/profile.php?id=100064115081323",
                label: "Facebook",
            },
            {
                icon: <Instagram />,
                url: "https://www.instagram.com/colegioantilenrengo/channel/",
                label: "Instagram",
            },
            {
                icon: <YouTube />,
                url: "https://www.youtube.com/channel/UC-hJsXRYyBvLzPjnCfov2GQ",
                label: "YouTube",
            },
        ].map((red, index) => (

            <IconButton
                key={red.label}

                component="a"

                href={red.url}

                target="_blank"

                rel="noopener noreferrer"

                aria-label={red.label}

                sx={{
                    ...IconRedes,

                    opacity: visible ? 1 : 0,

                    transform: visible
                        ? "translateY(0)"
                        : "translateY(30px)",

                    transition: "0.7s ease",

                    transitionDelay:
                        `${index * 0.15}s`,
                }}
            >

                {red.icon}

            </IconButton>

        ))}

    </Stack>

</Box>
                </Grid>
               <Grid size={{ xs: 12, md: 8 }} sx={{

opacity:visible?1:0,

transform:visible
?
"translateY(0)"
:
"translateY(30px)",


transition:"0.7s ease",

transitionDelay:".4s"

}}>
  <Box
    component="form"
    onSubmit={handleSubmit}
>
  <Grid container spacing={2.5}>

    <Grid size={12} sx={{

opacity:visible?1:0,

transform:visible
?
"translateY(0)"
:
"translateY(30px)",


transition:"0.7s ease",

transitionDelay:".4s"

}}>
      <TextField
    fullWidth
    name="nombre"
    label="Nombre"
    value={formulario.nombre}
    onChange={handleChange}
    sx={InputContacto}
/>
    </Grid>

    <Grid size={12} sx={{

opacity:visible?1:0,

transform:visible
?
"translateY(0)"
:
"translateY(30px)",


transition:"0.7s ease",

transitionDelay:".4s"

}}>
      <TextField
    fullWidth
    name="email"
    type="email"
    label="Correo electrónico"
    value={formulario.email}
    onChange={handleChange}
    sx={InputContacto}
/>
    </Grid>

    <Grid size={{ xs: 12 }} sx={{

opacity:visible?1:0,

transform:visible
?
"translateY(0)"
:
"translateY(30px)",


transition:"0.7s ease",

transitionDelay:".4s"

}}>
      <Stack direction="row" spacing={1}>
        <TextField
          value="+56"
          disabled
          sx={{
            width: 85,
            ...InputContacto,
          }}
        />

       <TextField
    fullWidth
    name="telefono"
    label="Teléfono"
    value={formulario.telefono}
    onChange={handleChange}
    sx={InputContacto}
/>
      </Stack>
    </Grid>

    <Grid size={{ xs: 12 }} sx={{

opacity:visible?1:0,

transform:visible
?
"translateY(0)"
:
"translateY(30px)",


transition:"0.7s ease",

transitionDelay:".4s"

}}>
      <TextField
    fullWidth
    name="mensaje"
    multiline
    rows={5}
    label="Mensaje"
    value={formulario.mensaje}
    onChange={handleChange}
    sx={InputContacto}
/>
    </Grid>

    <Grid size={{ xs: 12 }} sx={{

opacity:visible?1:0,

transform:visible
?
"translateY(0)"
:
"translateY(30px)",


transition:"0.7s ease",

transitionDelay:".4s"

}}>
  <Stack
    direction={{ xs: "column", lg: "row" }}
    spacing={2}
    alignItems={{ xs: "stretch", lg: "center" }}
    mt={2}
  >
    {/* BOTÓN ENVIAR */}
    <Button
    type="submit"
    variant="contained"
    sx={{
        px: 5,
        height: 40,
        borderRadius: "30px",
        background: "#484a75",
        color: "#fff",
        textTransform: "none",
        fontSize: "0.8rem",
        fontWeight: 600,
        boxShadow: "none",

        "&:hover": {
          background: "#3d3f66",
          boxShadow: "0 8px 20px rgba(72,74,117,.25)",
        },
      }}
    >
      Enviar 
    </Button>

    {/* BOTÓN TELÉFONO */}
    <Button
     component="a"
  href="tel:+56 9 3238 5589"
      startIcon={<Phone />}
      variant="outlined"
      sx={{
        px: 5,
        height: 40,
        borderRadius: "30px",
        background: "#484a75",
        color: "#fff",
        textTransform: "none",
        fontSize:{xs:'0.6rem',sm:'0.7rem', md:"0.8rem"},
        fontWeight: 600,
        boxShadow: "none",

        "&:hover": {
          background: "#3d3f66",
          boxShadow: "0 8px 20px rgba(72,74,117,.25)",
        },
      }}
    >
      +56 9 3238 5589
    </Button>

    {/* BOTÓN CORREO */}
    <Button
     component="a"
  href="mailto:contacto@colegioantilenrengo.cl"
      startIcon={<Email />}
      variant="outlined"
      sx={{
        px: 5,
        height: 40,
        borderRadius: "30px",
        background: "#484a75",
        color: "#fff",
        textTransform: "none",
        fontSize:{xs:'0.6rem',sm:'0.7rem', md:"0.8rem"},
        fontWeight: 600,
        boxShadow: "none",

        "&:hover": {
          background: "#3d3f66",
          boxShadow: "0 8px 20px rgba(72,74,117,.25)",
        },
      }}
    >
      contacto@colegioantilenrengo.cl
    </Button>
  </Stack>
</Grid>

  </Grid>
  </Box>
</Grid>

<Grid size={12} sx={{

opacity:visible?1:0,

transform:visible
?
"translateY(0)"
:
"translateY(30px)",


transition:"0.7s ease",

transitionDelay:".4s"

}}>
  <Box
    sx={{
      mt: 4,
      borderRadius: "20px",
      overflow: "hidden",
      boxShadow: "0 10px 30px rgba(0,0,0,.12)",
    }}
  >
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3964.925784010157!2d-70.85840158792757!3d-34.402362546780985!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x96649fb58805c0a9%3A0x7b89960043ddcf21!2sArturo%20Prat%20856%2C%202940455%20Rengo%2C%20O'Higgins!5e1!3m2!1ses-419!2scl!4v1785337949104!5m2!1ses-419!2scl"
      width="100%"
      height="450"
      style={{ border: 0 }}
      allowFullScreen
      loading="lazy"
      referrerPolicy="strict-origin-when-cross-origin"
      title="Ubicación Colegio Antilén"
    />
  </Box>
  <Typography
   sx={{
              fontWeight: 500,
              color: "#666",
              mt:2,
              fontSize: {
                xs: "0.8rem",
                sm: "0.9rem",
                
              },
              width:'80%',
              lineHeight: 1.1,
              textAlign: "left",
            }}
            > Arturo Prat 856,  Rengo, O'Higgins, Chile</Typography>
</Grid>
            </Grid>
            
         </Paper>
         </Box>
         <StatusModal
    open={modal.open}
    status={modal.status}
    title={modal.title}
    message={modal.message}
    buttonText={
        modal.status === "loading"
            ? ""
            : "Continuar"
    }
    onClose={() =>
        setModal((prev) => ({
            ...prev,
            open: false,
        }))
    }
    showClose={modal.status !== "loading"}
/>
        </Container>
    )
}

const InputContacto = {
  "& .MuiOutlinedInput-root": {
    background: "transparent",
    borderRadius: "14px",
fontSize:{xs:'0.8rem', sm:'1rem'},
    "& fieldset": {
      border: "1px solid rgba(88,88,87,.25)",
    },

    "&:hover fieldset": {
      borderColor: "#484a75",
    },

    "&.Mui-focused fieldset": {
      borderColor: "#484a75",
      borderWidth: "2px",
    },
  },

  "& .MuiInputLabel-root": {
    color: "#585857",
    fontWeight: 500,
    fontSize:{xs:'0.8rem', sm:'1rem'},
  },

  "& .MuiInputLabel-root.Mui-focused": {
    color: "#484a75",
  },

  "& .MuiOutlinedInput-input": {
    color: "#585857",
    py: 1.7,
  },
};

  const IconRedes = {
    width:{xs:35,sm:40,md:55},
    height:{xs:35,sm:40,md:55},
    color:"#585857",
    boxShadow:"0 8px 18px rgba(0,0,0,.08)",

    "&:hover":{
        background:"#484a75",
        color:"#fff",
    }
}